<script>
    import { onMount } from "svelte";
    import loader from "@beyonk/async-script-loader";
    import { bingStore } from "./store";
    import { addConsent, addPageLoad } from "./functions";

    /** @type {string[]} */
    export let properties;
    export let enabled = true;
    export let cookieConsent = false;

    let mounted = false;
    let initialized = false;

    $: initialized && updateConsent(cookieConsent);

    /** @param {boolean} isGranted */
    function updateConsent(isGranted) {
        if (isGranted) {
            addConsent("update", { ad_storage: "granted" });
        } else {
            addConsent("update", { ad_storage: "denied" });
        }
    }

    onMount(() => {
        mounted = true;
        if (!enabled) {
            return;
        }
        init();
    });

    function init() {
        loader(
            [
                {
                    type: "script",
                    url: `//bat.bing.com/bat.js`,
                },
            ],
            test,
            callback,
        );
    }
    function test() {
        return Boolean(window.uetq).valueOf() && Array.isArray(window.uetq);
    }
    function uetq() {
        if (!mounted || !enabled) {
            return;
        }
        window.uetq.push(...arguments);
    }
    function callback() {
        window.uetq = window.uetq || [];

        // If no property is set, we don't want to track anything
        if (!properties[0]) {
            enabled = false;
            return;
        }

        window.uetq = new UET({
            disableAutoPageView: true,
            ti: properties[0],
        });
        addPageLoad();
        addConsent("default", { ad_storage: "denied" });
        initialized = true;
        return bingStore.subscribe((queue) => {
            let next = queue.length && queue.shift();

            while (next) {
                const { type } = next;
                /** @type {any[]} */
                const args = [type];
                if ("event" in next) {
                    args.push(next.event);
                }
                if ("data" in next) {
                    args.push(next.data);
                }
                uetq(...args);
                next = queue.shift();
            }
        });
    }
</script>
